import React, { useState, useEffect } from 'react';
import { Badge, Box, Button, Checkbox, Container, Form, FormField, Grid, Header, Input, Link, RadioGroup, SpaceBetween, TextContent } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { useGlobalState } from '../../../context/GlobalStateContext'
import { getParameter, storeJWT } from '../../../commons/functions';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { CiTextAlignCenter } from 'react-icons/ci';
//import { Circle, GoogleMap, LoadScript, Marker } from '@react-google-maps/api';


type Unit = {
    idUnidad: string;
    allowDistanceOpenInmueble: number;
    unidad: string;
    quotaMax: string;
    quotaActual: string;
    reqInfoUnidad: number;
    reqInfoTitle: string;
    canHandleGuests: number;
    isBlockUnit: string;
    pendingCount: string;
    users: any[];
};
//allowDistanceOpenInmueble -1 ILIMITADO 0 allowDistanceOpenInmueble >0 CUSTOM
export const ConfigUnitEditPage = () => {
    const storeAdmin = useStoreAdmin();
    const { JWT, setJWT } = useGlobalState();

    const [canHandleGuests, setCanHandleGuests] = useState(false);
    const [reqInfoTitle, setReqInfoTitle] = useState('');
    const [reqInfoUnidad, setReqInfoUnidad] = useState(0);
    const [unidad, setUnidad] = useState('');
    const [allowDistanceOpenInmueble, setAllowDistanceOpenInmueble] = useState("-2");
    const [allowDistance, setAllowDistance] = useState(0);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    //const mapRef = useRef(null);
    const { setLoading } = useGlobalState();
    const [unit, setUnit] = useState<Unit>();

    // Example input string



    const id = getParameter(window.location.hash, 'id');
    const handleRefresh = async () => {
        try {

            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/units/getunit',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idUnidad: id
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();

            storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

            console.log(data.unit)
            setUnit(data.unit);
            setReqInfoTitle(data.unit.reqInfoTitle)
            setReqInfoUnidad(data.unit.reqInfoUnidad)
            setUnidad(data.unit.unidad)
            if (data.unit.allowDistanceOpenInmueble > 0) {
                setAllowDistanceOpenInmueble("1")
            } else {
                setAllowDistanceOpenInmueble(data.unit.allowDistanceOpenInmueble.toString())
            }
            setAllowDistance(data.unit.allowDistanceOpenInmueble)
            setCanHandleGuests(data.unit.canHandleGuests === 1)

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        setTimeout(function () { handleRefresh() }, 0);
    }, []);

    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Configuración', href: '#config/default' },
                        { text: 'Unidades', href: '#config/units' },
                        { text: 'Editar Unidad', href: '#create-transcription-job' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <Container

                    footer={
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button formAction="none" variant="link" href='#config/units'>
                                Cancelar
                            </Button>
                            <Button variant="primary" formAction='none'>Guardar</Button>
                        </SpaceBetween>
                    }
                    header={<Header variant="h1"
                        description={unit?.users?.length && (
                            <Badge color="blue">{unit.users.length} usuario{unit.users.length > 1 ? "s" : ""}</Badge>
                        )}>Editar unidad {unidad}</Header>}

                >
                    <div style={{ maxWidth: 300 }}>
                        <SpaceBetween direction='vertical' size='xs'>
                            <FormField
                                //description="This is a description."
                                label="Unidad"
                            >
                                <Input

                                    value={unidad ?? ''}
                                    onChange={event =>
                                        setUnidad(event.detail.value)
                                    }
                                />
                            </FormField>
                            <FormField
                                label="Permitir invitados"
                            >
                                <Checkbox checked={canHandleGuests}
                                    onChange={event => setCanHandleGuests(event.detail.checked)}
                                >Habilitado</Checkbox>
                            </FormField>

                            <FormField
                                label="Info adicional"
                            >
                                <Checkbox checked={reqInfoUnidad === 1}
                                    onChange={event => setReqInfoUnidad(event.detail.checked ? 1 : 0)}
                                >Habilitado</Checkbox>
                            </FormField>
                            {reqInfoUnidad === 1 && (
                                <FormField
                                    label="Información solicitada"
                                >
                                    <Input
                                        //disabled={reqInfoUnidad === 0}

                                        value={unit?.reqInfoTitle?.toString() ?? ''}
                                        onChange={event =>
                                            setReqInfoTitle(event.detail.value)
                                        }
                                    />
                                </FormField>
                            )}



                            <FormField
                                label="Restricción de distancia"
                            >
                                <RadioGroup
                                    onChange={({ detail }) => setAllowDistanceOpenInmueble(detail.value)}
                                    value={allowDistanceOpenInmueble}
                                    items={[
                                        { value: "-1", label: "Ilimitado" },
                                        { value: "0", label: "Heredado" },
                                        { value: "1", label: "Personalizado" },
                                    ]}
                                />
                            </FormField>
                            {allowDistanceOpenInmueble === "1" && (
                                <FormField
                                    label={`Distancia  personalizada`}
                                >
                                    <Input
                                        type='number'
                                        disabled={allowDistanceOpenInmueble != "1"}

                                        value={allowDistance.toString() ?? ''}
                                        onChange={event => {
                                            if (Number(event.detail.value) > 0) {
                                                setAllowDistance(Number(event.detail.value));
                                            }
                                        }}
                                    />
                                </FormField>
                            )}
                        </SpaceBetween>
                    </div>
                </Container>
            }
        />
    );
};
